export const HIDDEN_LIMIT_QUOTE_BUILDER_FORM_ID =
  'hidden-limit-quote-builder-form';
